'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _history = require('history');

var _omit = require('hs-lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

var _I18n = require('I18n');

var i18n = _interopRequireWildcard(_I18n);

var _HubSpotOnlyAppCookieLogin = require('Nabisco/app/HubSpotOnlyAppCookieLogin');

var _HubSpotOnlyAppCookieLogin2 = _interopRequireDefault(_HubSpotOnlyAppCookieLogin);

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _handlers = require('q/js/handlers');

var _Raven = require('Raven');

var _Raven2 = _interopRequireDefault(_Raven);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactRedux = require('react-redux');

var _reactRhumb = require('react-rhumb');

var _historyAdapterV = require('react-rhumb/historyAdapterV3');

var _historyAdapterV2 = _interopRequireDefault(_historyAdapterV);

var _reactRouter = require('react-router');

var _reactRouterRedux = require('react-router-redux');

var _usageTrackerContainer = require('usage-tracker-container');

var _UserInfoActions = require('../core/actions/UserInfoActions');

var _AnalyticsActions = require('./actions/AnalyticsActions');

var _LocaleActions = require('./actions/LocaleActions');

var _PartnerActions = require('./actions/PartnerActions');

var _AppConfigContainer = require('./globals/AppConfigContainer');

var _AppConfigContainer2 = _interopRequireDefault(_AppConfigContainer);

var _LandingPageDisplayContainer = require('./globals/LandingPageDisplayContainer');

var _LandingPageDisplayContainer2 = _interopRequireDefault(_LandingPageDisplayContainer);

var _QueryParamsContainer = require('./globals/QueryParamsContainer');

var _QueryParamsContainer2 = _interopRequireDefault(_QueryParamsContainer);

var _StepsConfigContainer = require('./globals/StepsConfigContainer');

var _StepsConfigContainer2 = _interopRequireDefault(_StepsConfigContainer);

var _loadFireAlarm = require('./loadFireAlarm');

var _loadFireAlarm2 = _interopRequireDefault(_loadFireAlarm);

var _reduxStore = require('./reduxStore');

var _reduxStore2 = _interopRequireDefault(_reduxStore);

var _Routes = require('./Routes');

var _Routes2 = _interopRequireDefault(_Routes);

var _rhumbConfig = require('./sla/rhumb-config.yaml');

var _rhumbConfig2 = _interopRequireDefault(_rhumbConfig);

var _getTrackerProperties = require('./tracking/getTrackerProperties');

var _getTrackerProperties2 = _interopRequireDefault(_getTrackerProperties);

var _UsageTrackerContainer = require('./tracking/UsageTrackerContainer');

var _UsageTrackerContainer2 = _interopRequireDefault(_UsageTrackerContainer);

var _enforceSettingsRules = require('./utils/enforceSettingsRules');

var _enforceSettingsRules2 = _interopRequireDefault(_enforceSettingsRules);

var _raven = require('./utils/raven');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var appCookieLogin = new _HubSpotOnlyAppCookieLogin2.default();

var Application = function () {
  function Application(opts) {
    _classCallCheck(this, Application);

    (0, _enforceSettingsRules2.default)(opts);

    this.appName = opts.appName;
    this.baseHistoryPath = opts.baseHistoryPath;
    this.steps = opts.steps;
    this.landingPageContent = opts.landingPageContent;
    this.opts = (0, _omit2.default)(opts, ['steps', 'landingPageContent']);
    this.history = (0, _reactRouter.useRouterHistory)(_history.createHistory)();
    this.store = (0, _reduxStore2.default)(this.history);
  }

  _createClass(Application, [{
    key: 'start',
    value: function start(defaultUserValues) {
      var _this = this;

      if (window.jasmine) return;

      (0, _loadFireAlarm2.default)();
      appCookieLogin.loginPrep();

      (0, _handlers.logQPromiseIssuesAndSendAlerts)();

      // Filter sentries before triggering them
      _Raven2.default.setDataCallback(_raven.ravenDataCallback);

      // Store steps and options config
      _QueryParamsContainer2.default.hydrate();
      _AppConfigContainer2.default.set(this.opts);
      _StepsConfigContainer2.default.set(this.steps);
      _LandingPageDisplayContainer2.default.set(this.landingPageContent);

      // ?intent=<intentKey>
      _AppConfigContainer2.default.set({ intentKey: _QueryParamsContainer2.default.get('intent') });

      // ?integration=<integrationKey>
      if (_AppConfigContainer2.default.get('intentKey') === 'connectIntegration') {
        _AppConfigContainer2.default.set({
          integrationKey: _QueryParamsContainer2.default.get('integration')
        });
      }

      if (defaultUserValues) {
        this.store.dispatch((0, _UserInfoActions.updateUser)(defaultUserValues));
      }

      //email, token for email verification if any
      var token = _QueryParamsContainer2.default.get('token');
      var email = _QueryParamsContainer2.default.get('email');

      if (token && email) {
        this.store.dispatch((0, _UserInfoActions.updateUser)({
          email: email,
          token: token
        }));
      }

      _UsageTrackerContainer2.default.setProperties((0, _getTrackerProperties2.default)());
      (0, _usageTrackerContainer.setPrimaryTracker)(_UsageTrackerContainer2.default.get());
      (0, _AnalyticsActions.trackEvent)('view', { screen: 'initialization' });

      this.store.dispatch((0, _UserInfoActions.preFillFieldsFromQueryParams)());
      this.store.dispatch((0, _UserInfoActions.preFillFieldsFromVisitorContext)());

      var partnerId = _QueryParamsContainer2.default.get('partnerId');
      if (partnerId) {
        this.store.dispatch((0, _PartnerActions.partnerIdFromQueryParam)(partnerId));
      }

      _q2.default.Promise.resolve(i18n.Info).then(
      // Grab the language of the user's browser and show that one.
      this.store.dispatch((0, _LocaleActions.getPreferredLocale)())).then(function () {
        return _this.startRouter();
      }).done();
    }
  }, {
    key: 'startRouter',
    value: function startRouter() {
      var syncedHistory = (0, _reactRouterRedux.syncHistoryWithStore)(this.history, this.store, {
        selectLocationState: function selectLocationState(state) {
          return state.router;
        }
      });

      (0, _reactDom.render)(_react2.default.createElement(
        _reactRhumb.RhumbProvider,
        {
          history: (0, _historyAdapterV2.default)(syncedHistory),
          config: _rhumbConfig2.default
        },
        _react2.default.createElement(
          _reactRedux.Provider,
          { store: this.store },
          _react2.default.createElement(
            _reactRouter.Router,
            { history: syncedHistory },
            (0, _Routes2.default)(this.appName)
          )
        )
      ), document.getElementsByClassName('page')[0]);
    }
  }]);

  return Application;
}();

exports.default = Application;
module.exports = exports['default'];